/* import __COLOCATED_TEMPLATE__ from './project-version-destroyer.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { later } from '@ember/runloop';
import canUserManageProject from 'seshy/utils/can-user-manage-project';

export default class ProjectVersionDestroyer extends Component {
  @service currentUser;
  @service projectVersionRepository;
  @service router;

  @tracked isDestroying = false;
  @tracked isDestroyingLocal = false;
  @tracked isDestroyingCloud = false;
  @tracked projectNameConfirmation = '';
  @tracked hasLocalProject = true;
  @tracked localProjectPath = '';

  @tracked errorMessage = null;

  get hasError() {
    return !!this.errorMessage;
  }

  get canManageProject() {
    return canUserManageProject(this.currentUser, this.args.projectVersion.project);
  }

  @action
  async checkLocalProject() {
    console.log('this.args.projectVersion.projectId = ', this.args.projectVersion.projectId)
    var projectData = this.projectVersionRepository.dataFor(
      this.args.projectVersion.projectId,
    );
    console.log('project data = ', projectData);
    if (projectData) {
      // TODO: Extract fs handling to a dedicated service so that we can
      // stub it in tests. (Especially browser based which is how we get coverage data.)
      const fs = window.requireNode('fs');
      this.localProjectPath = projectData.localPath;
      if (fs.existsSync(projectData.localPath) && projectData.currentProjectVersionId == this.args.projectVersion.id) {
        this.hasLocalProject = true;
      } else {
        this.hasLocalProject = false;
      }
    } else {
      this.hasLocalProject = false;
    }
  }

  get projectNameConfirmed() {
    return this.projectNameConfirmation == 'delete forever';
  }

  get projectNameNotConfirmed() {
    return !this.projectNameConfirmed;
  }

  @action
  startDestroying() {
    console.log('startDestroying');
    this.isDestroying = true;
  }

  @action
  cancel() {
    this.isDestroying = false;
  }

  @action
  async finishDestroying() {
    this.isDestroyingCloud = true;
    console.log('finishDestroying');
    let projectVersion = this.args.projectVersion;
    try {
      let project = this.args.projectVersion.project;
      // TODO: Do we need to doink with the projectVersionRepository?
      //var projectId = project.get('id');
      await projectVersion.destroyRecord();

      //var projectData = this.projectVersionRepository.dataFor(projectId);
      //if (projectData) {
        //this.projectVersionRepository.removeProjectDataByLocalPath(
          //projectData.localPath,
          //{ skipSave: true },
        //);
      //}

      this.isDestroyingCloud = false;
      // TODO: We should not redirect from within the component, we should
      // fire an event or accept a callback function that we could call here.
      // This makes testing the component weird because we have to stub the router.
      if (project) {
        this.router.transitionTo('authenticated.projects.show.project-versions.list');
      } else {
        this.router.transitionTo('authenticated.index');
      }
    } catch (error) {
      console.log('caught an error', error);
      this.isDestroyingCloud = false;
      let errorCause = error.errors[0];

      if (errorCause.status == '403') {
        this.setForbiddenMessage();
      } else {
        this.setUnknownErrorMessage();
        throw error;
      }
    }
  }

  @action
  async openParentFolder() {
    const { ipcRenderer } = window.requireNode('electron');
    await ipcRenderer.invoke('show-item-in-folder', this.localProjectPath);
  }

  @action
  async deleteLocalCopy() {
    this.isDestroyingLocal = true;

    console.log('delete local copy');
    const shell = window.requireNode('electron').shell;
    const fs = window.requireNode('fs');
    try {
      let trashData = await shell.trashItem(this.localProjectPath);
      console.log('trashData = ', trashData);
    } catch (err) {
      if (!fs.existsSync(this.localProjectPath)) {
        console.log('It seems the local copy was deleted outside of Seshy.');
      } else {
        throw err;
      }
    }

    this.projectVersionRepository.removeProjectDataByLocalPath(
      this.localProjectPath,
      { skipSave: true },
    );

    // We delay checking again because it takes a few seconds for the
    // upload manager to notice the change and remove it from the repo.
    later(() => {
      this.checkLocalProject();
      this.isDestroyingLocal = false;
    }, 3000);
  }

  setForbiddenMessage() {
    this.errorMessage =
      "You don't seem to be a Team Admin for the team that owns this project.";
  }

  setUnknownErrorMessage() {
    this.errorMessage =
      'We ran into an unexpected error while trying to delete this project. Please try again.';
  }

}
